module.exports = __webpack_public_path__ + "static/img/logotipo-strategio.06fb004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logotipo-strategio.png
// module id = 9FQj
// module chunks = 3